<template>
    <div class="module page-header sinMargin">
        <h2 class="title--xs title-line" style="font-family: Heebo; font-weight: normal">DATOS DEL CLIENTE</h2>
        <fieldset class="form-fieldset module">
            <div class="form-row">
                <div class="input input--text input--s">
                    <label class="title--xs mb-0" style="font-family: Heebo; font-weight: normal">Teléfono</label>
                    <div class="input-item">
                        <input v-model="cliente.telefono" maxlength="15" class="text--s" type="tel" disabled style="background-color:LightGrey;">
                    </div>
                </div>
                <div class="input input--text input--s">
                    <label class="title--xs mb-0" style="font-family: Heebo; font-weight: normal">DNI</label>
                    <div class="input-item">
                        <input v-model="cliente.dni" maxlength="9" class="text--s" disabled style="background-color:LightGrey;">
                    </div>
                </div>
            </div>
            <div class="form-row cc_cursor">
                <div class="input input--text input--s">
                    <label class="title--xs mb-0" style="font-family: Heebo; font-weight: normal">E-Mail</label>
                    <div class="input-item">
                        <input v-model="cliente.mail" type="email"  maxlength="60" class="text--s" disabled style="background-color:LightGrey;">
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</template>

<script>
    export default {    
        created() {
            this.cliente = this.$bus.datosUsuario.cliente
        },        

        data: () => ({
            cliente: Object,
        }),
    }
</script>

<style scoped>
    .v-alert__content {
        padding-left: 10px !important;
    }
</style>